/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddClientToServiceProviderRequest
 */
export interface AddClientToServiceProviderRequest {
    /**
     * The org id to which our service provider is provided
     * @type {string}
     * @memberof AddClientToServiceProviderRequest
     */
    clientOrgId: string;
    /**
     * Service provider id. One org can have several service provider roles
     * @type {string}
     * @memberof AddClientToServiceProviderRequest
     */
    serviceProviderId: string;
    /**
     * User Id
     * @type {string}
     * @memberof AddClientToServiceProviderRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof AddClientToServiceProviderRequest
     */
    scopedOrgId?: string;
}

/**
 * Check if a given object implements the AddClientToServiceProviderRequest interface.
 */
export function instanceOfAddClientToServiceProviderRequest(value: object): boolean {
    if (!('clientOrgId' in value)) return false;
    if (!('serviceProviderId' in value)) return false;
    if (!('userId' in value)) return false;
    return true;
}

export function AddClientToServiceProviderRequestFromJSON(json: any): AddClientToServiceProviderRequest {
    return AddClientToServiceProviderRequestFromJSONTyped(json, false);
}

export function AddClientToServiceProviderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddClientToServiceProviderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientOrgId': json['clientOrgId'],
        'serviceProviderId': json['serviceProviderId'],
        'userId': json['userId'],
        'scopedOrgId': json['scopedOrgId'] == null ? undefined : json['scopedOrgId'],
    };
}

export function AddClientToServiceProviderRequestToJSON(value?: AddClientToServiceProviderRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientOrgId': value['clientOrgId'],
        'serviceProviderId': value['serviceProviderId'],
        'userId': value['userId'],
        'scopedOrgId': value['scopedOrgId'],
    };
}

